const init = {
  paid: false,
  productnumber: 0
};

const invoice = (state = init, action) => {
  switch (action.type) {
    case "GET_INVOICE":
      return {
        ...state,
        paid: action.paid,
        productnumber: action.number
      };
    default:
      return state;
  }
};

export default invoice;
